import React from "react";
import { Route, Switch } from "react-router-dom";

import * as QueriesQL from "queries/section";
import SectionPublicSchema from "@common/schema/section/public";
import * as Section from "@repoflow/components/section";
import { Crumb } from "@repoflow/components/breadcrumb";

import * as ViewRoute from "./view";
import * as EditRoute from "./edit";
import * as RemoveRoute from "./remove";

const LocalProvider = ({
  match: {
    params,
    params: { sectionId },
  },
  children: Children,
}) => {
  const { base: parentBase, basepath: parentBasepath } =
    Section.useSectionContext();

  const base = `${parentBase}/${sectionId}`;
  const basepath = `${parentBasepath}/:sectionId`;

  // Keyed on the entity, which is what the accidental remount used to do.
  //
  // Every screen below seeds its form state ONCE, from the entity this
  // route resolved. Until the render prop above was called rather than
  // rendered, React saw a new component type on every render and remounted
  // the lot — which reset those forms, and happened to be what made moving
  // from one sectionId to another show the new one's values. It no longer
  // remounts for free, so the reset it was providing is asked for here.
  return (
    <Section.Provider
      key={sectionId}
      schema={SectionPublicSchema}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ params }) => (
        <Section.Query
          query={QueriesQL.get}
          variables={params}
          datapath={"sites.get.sections.get"}
        >
          {ContentHandler}
        </Section.Query>
      )}
    </LocalProvider>
  );
}

function ContentHandler({ basepath }) {
  return (
    <Switch>
      <Route path={`${basepath}/remove`} component={RemoveRoute.Content} />
      <Route path={`${basepath}/edit`} component={EditRoute.Content} />
      <Route path={`${basepath}`} component={ViewRoute.Content} />
    </Switch>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath, params: { sectionId } }) => (
        <>
          {/* No useCrumbLabel here, unlike a page's. A page's id is a generated
              uuid and says nothing, so its crumb has to fetch the title; a
              section's id IS its name. Fetching to render what is already in
              the URL would be a query per navigation for no new information. */}
          <Crumb to={`${base}`} label={sectionId} />

          <Switch>
            <Route path={`${basepath}/remove`} component={RemoveRoute.Indice} />
            <Route path={`${basepath}/edit`} component={EditRoute.Indice} />
            <Route path={`${basepath}`} component={ViewRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => (
  <>
    <EditRoute.Sidebar />
    <ViewRoute.Sidebar />
  </>
);
